import React, { useEffect, useState } from "react";
import { toast} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "../api/baseurl";
import { Modal, Button } from "react-bootstrap";
import "./Spinner.css";
import { useNavigate } from "react-router";

const UploadPemeReport = ({ isOpen, onRequestClose, pemeAppointmentId }) => {
  const [report, setReport] = useState("");

  const [appReport, setAppReport] = useState({
    pemeAppointmentId:pemeAppointmentId,
    file: null,
    fileSize: "",
    fileContentType:""
  });

 
  const [loading, setLoading] = useState(false);

 const getData = async () => {
      const token = JSON.parse(localStorage.getItem("data")).token;
      setLoading(true);
      try {
        const searchUrl = `/api/peme-appointment-reports/pemeAppointmentId=${pemeAppointmentId}`;
        const response = await axios.get(searchUrl, {
          headers: { Authorization: `Bearer ${token}` },
        });
        
        setReport(response.data);
        // setFilteredData(response.data);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        handleError(error);
      }
    };
  

  useEffect(() => {
   getData();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const token = JSON.parse(localStorage.getItem("data")).token;
  
    try {
      let response;
  
      if (report) {
        // Update existing report
        response = await axios.post(`/api/peme-appointment-reports/update-report`, appReport, {
          headers: { Authorization: `Bearer ${token}` },
        });
        toast.success("PEME Report updated successfully");
      } else {
        // Create new report
        response = await axios.post("/api/peme-appointment-reports/upload-report", appReport, {
          headers: { Authorization: `Bearer ${token}` },
        });
        toast.success("PEME Report uploaded successfully");
      }
  
      console.log(response.data);
      setLoading(false);
      onRequestClose();
      setAppReport("");
      setReport("");
      getData(); // Refresh data after upload/update
    } catch (error) {
      setLoading(false);
      handleError(error);
    }
  };
  

  const navigate = useNavigate();
  function handleError(error) {
    if (error.response) {
      if (error.response.status === 401) {
        navigate(`/signin`);
        toast.error("Your session has expired. Please login.");
      } else if (error.response.data && error.response.data.message) {
        toast.error(error.response.data.message);
      }  else if (error.response.data && error.response.data.code) {
        toast.error(error.response.data.code);
      }
       else {
        toast.error("An error occurred.");
      }
    } else if (error.message) {
      toast.error(error.message);
    } else {
      toast.error("An error occurred.");
    }
  }

  function getBase64FromFile(file) {
    return new Promise((resolve, reject) => {
      var reader = new FileReader();

      reader.readAsDataURL(file);

      reader.onload = function () {
        const [metadata, content] = reader.result.split(",");

        resolve({ metadata, content });
      };

      reader.onerror = function (error) {
        reject(error);
      };
    });
  }
  const handlePdfFileChange = async (e) => {
    const file = e.target.files[0];
    const convertedPdf = await getBase64FromFile(file);
    const pdfObject = {
      ...appReport,

      file: convertedPdf.content,
      fileSize: file.size,
      fileContentType:convertedPdf.metadata
    };

    setAppReport(pdfObject);
  };

  return (
    <Modal show={isOpen} onHide={onRequestClose} centered >
      <Modal.Header closeButton>
      {loading && <div className="loading"></div>}
        <Modal.Title>Upload PEME Report</Modal.Title>
      </Modal.Header>
      <Modal.Body>
      {loading && <div className="loading"></div>} 
        <div className="col-xl-10 mx-xl-auto">
          <div className="card card-raised mb-3">
            <div className="card-body p-4 ">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="form-floating-sm mb-2">
                    <label htmlFor="file" className="me-1">Upload File:<span style={{color:"red"}}>* </span></label>
                    <input
                                  className="form-control smaller-input flex-grow-1"
                                  id="file"
                                  type="file"
                                  placeholder="Upload document"
                                  onChange={(e) => handlePdfFileChange(e)}
                                  required
                                />
                  </div>
                </div>
                <br/>
                <input
                  type="submit"
                  value="SAVE"
                  className="btn btn-primary"
                  disabled={loading}
                />
                &nbsp;&nbsp;&nbsp;&nbsp;
                <Button variant="secondary" onClick={onRequestClose}>
                  Close
                </Button>
              </form>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer />
    </Modal>
  );
};

export default UploadPemeReport;
